(function () {
  const STORAGE_KEY = 'tnws-announcement-dismissed';
  const section = document.querySelector('.announcement-bar-section');

  if (!section || localStorage.getItem(STORAGE_KEY) === 'true') {
    if (section) section.hidden = true;
    return;
  }

  const closeButton = section.querySelector('[data-announcement-close]');
  if (!closeButton) return;

  closeButton.addEventListener('click', () => {
    section.hidden = true;
    localStorage.setItem(STORAGE_KEY, 'true');
  });
})();
